exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "u{border-bottom:1px dotted #000;text-decoration:none}", ""]);

// exports
